import { BrowserManagerEffects } from './browser-manager.effects';
import { AppEffects } from './app.effects';

export const effects = [BrowserManagerEffects, AppEffects];

export { BrowserManagerEffects, AppEffects };
